import { useMemo } from 'react'
import {
  CompositeMetricChartLayout,
  useCompositeChartState,
} from '@/components/custom/companies/financials/composite-metric-chart'
import {
  usePortalExpandedMetricSeries,
  usePortalMetricLabelOptions,
} from '@/hooks/use-portal-metrics'
import type { FinancialMetricOption } from '@/hooks/use-metrics'

const EMPTY_METRIC_OPTIONS: FinancialMetricOption[] = []

export function PortalCompositeMetricChart() {
  const { data } = usePortalMetricLabelOptions()
  const allMetricOptions = data ?? EMPTY_METRIC_OPTIONS

  // KPIs are mixed-unit and don't share an axis with financial metrics.
  // The portal label-options endpoint already drops sensitive labels
  // (IRR/MOIC) and excluded type codes; KPIs are still surfaced so we
  // filter them here for consistency with the internal chart.
  const metricOptions = useMemo(
    () => allMetricOptions.filter((opt) => opt.category !== 'KPI'),
    [allMetricOptions]
  )

  const state = useCompositeChartState(metricOptions)
  const { period, view, effectiveBarMetricId, effectiveLineMetricId } = state

  const { series: barSeries, isFetching: barFetching } =
    usePortalExpandedMetricSeries(
      effectiveBarMetricId,
      period,
      Boolean(effectiveBarMetricId),
      view
    )
  const { series: lineSeries, isFetching: lineFetching } =
    usePortalExpandedMetricSeries(
      effectiveLineMetricId,
      period,
      Boolean(effectiveLineMetricId),
      view
    )

  return (
    <CompositeMetricChartLayout
      metricOptions={metricOptions}
      state={state}
      barSeries={barSeries}
      lineSeries={lineSeries}
      isFetching={barFetching || lineFetching}
    />
  )
}
